import { PRODUCT_IDS } from '@adsk/alloy-provider';
import zvaInitScript from './zvaInitScript';
const PRODUCTS = {
  [PRODUCT_IDS.PROJECT_ADMINISTRATION]: {
    id: 'Admin_Chat',
    buttonId: '5736T000000sY1g',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAlUAO_17b5b66e223'
  },
  [PRODUCT_IDS.BUILD]: {
    id: 'Build_Chat',
    buttonId: '5736T000000sY1M',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZARUA4_17b5b493e4d'
  },
  [PRODUCT_IDS.DOCS]: {
    id: 'Docs_Chat',
    buttonId: '5736T000000sY1l',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAqUAO_17b5b6970ef'
  },
  [PRODUCT_IDS.DESIGN_COLLABORATION]: {
    id: 'Collaborate_Design_Chat',
    buttonId: '5736T000000sY1b',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAgUAO_17b5b63684a'
  },
  [PRODUCT_IDS.INSIGHT]: {
    id: 'Insight_Chat',
    buttonId: '5736T000000sY1R',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAcUAO_17b5b6c5956'
  },
  [PRODUCT_IDS.MODEL_COORDINATION]: {
    id: 'Collaborate_Model_Chat',
    buttonId: '5736T000000sY1W',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAbUAO_17b5b5f7377'
  },
  [PRODUCT_IDS.TAKEOFF]: {
    id: 'Takeoff_Chat',
    buttonId: '5736T000000sY1q',
    eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I6T000000XZAWUA4_17b5b57760d'
  }
};
const backgroundColor = '#006eaf';
const CSS_STYLES = "\n  .embeddedServiceHelpButton .helpButton .uiButton {\n    background-color: ".concat(backgroundColor, " !important;\n    font-family: \"Artifakt Element\", sans-serif !important;\n    animation: delayShowServiceHelpButton 2s 1;\n  }\n\n  @keyframes delayShowServiceHelpButton {\n    0% {\n      opacity: 0;\n    }\n    66% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .embeddedServiceHelpButton .helpButton,\n  .embeddedServiceSidebar.sidebarMaximized.layout-docked .dockableContainer {\n    left: 10px;\n    right: auto;\n    max-height: 570px;\n  }\n  .embeddedServiceHelpButton .helpButton {\n    width: 147px;\n  }\n  .embeddedServiceHelpButton .uiButton .helpButtonLabel {\n    justify-content: initial !important;\n    margin-left: 4px;\n  }\n  .embeddedServiceSidebar .wrapper.chatMessage {\n    min-height: auto !important;\n  }\n  .embeddedServiceSidebar .uiButton--default {\n    background: #0085DE;\n    border: none;\n    box-shadow: none;\n    padding: 8px 15px;\n    text-shadow: none;\n  }\n  .embeddedServiceSidebar .uiButton--default span {\n    color: #FFF;\n  }\n  .offlineSupportUI .embeddedServiceSidebarForm .fieldList {\n    padding: 0;\n  }\n");
function addScript(script, onload) {
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('fetchPriority', 'low');
  Object.keys(script).forEach(key => {
    scriptElement.setAttribute(key, script[key]);
  });
  scriptElement.type = 'text/javascript';
  if (onload) scriptElement.onload = onload;
  const s = document.getElementsByTagName('script')[0];
  if (s) {
    s.parentNode.insertBefore(scriptElement, s);
  }
}
function addScripts(scripts, onLastLoad) {
  const onload = scripts.slice(1).length ? addScripts.bind(null, scripts.slice(1), onLastLoad) : onLastLoad;
  addScript(scripts[0], onload);
}

/**
 * Initialization and configuration script for the new Zoom Virtual Agent chat integration.
 * Zoom Virtual Agent (ZVA) replaced the Solvvy integration for the customer support chat
 * widget.
 * @param productId Product ID
 */
function initializeZvaChat() {
  let productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PRODUCT_IDS.BUILD;
  if (!URLSearchParams) return;
  const PRODUCT = PRODUCTS[productId] || PRODUCTS[PRODUCT_IDS.PROJECT_ADMINISTRATION];
  const initESW = function (gslbBaseURL) {
    window.embedded_svc.settings.displayHelpButton = false;
    window.embedded_svc.settings.language = ''; // e.g. 'en' or 'en-US'
    window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
    window.embedded_svc.settings.entryFeature = 'LiveAgent';
    window.embedded_svc.init('https://plangrid.my.salesforce.com', 'https://plangrid.my.site.com', gslbBaseURL, '00Dd0000000hAll', PRODUCT.id, {
      baseLiveAgentContentURL: 'https://c.la3-core1.sfdc-yfeipo.salesforceliveagent.com/content',
      deploymentId: '5720W000001YVMK',
      buttonId: PRODUCT.buttonId,
      baseLiveAgentURL: 'https://d.la3-core1.sfdc-yfeipo.salesforceliveagent.com/chat',
      eswLiveAgentDevName: PRODUCT.eswLiveAgentDevName,
      isOfflineSupportEnabled: false
    });
  };
  if (!window.embedded_svc) {
    const s = document.createElement('script');
    s.setAttribute('src', 'https://plangrid.my.salesforce.com/embeddedservice/5.0/esw.min.js');
    s.onload = function () {
      initESW(null);
    };
    document.body.appendChild(s);
  } else {
    initESW('https://service.force.com');
  }
}

/**
 * Load Zoom Virtual Agent chat scripts
 * @param onLoad Callback function to execute after scripts are loaded
 * @param productId Product ID
 */
function loadZvaScripts(onLoad, productId) {
  const style = document.createElement('style');
  document.head.appendChild(style);
  style.type = 'text/css';
  style.appendChild(document.createTextNode(CSS_STYLES));
  (function () {
    const scripts = [{
      src: 'https://service.force.com/embeddedservice/5.0/esw.min.js'
    }, {
      'data-apikey': 'K4N1YGvER0WpG1p1WNvJqQ',
      'data-env': 'us01',
      src: 'https://us01ccistatic.zoom.us/us01cci/web-sdk/chat-client.js'
    }];
    window.zoomCampaignSdkConfig = {
      enableSPAMode: true
    };
    addScripts(scripts, () => {
      zvaInitScript();
      initializeZvaChat(productId);
      onLoad === null || onLoad === void 0 ? void 0 : onLoad();
    });
  })();
}

// Function to handle the LCP event and load additional scripts
function onLCP(callback) {
  // Skip LCP check in test environment (Jest doesn't support PerformanceObserver)
  if (process.env.NODE_ENV === 'test') {
    callback();
    return;
  }
  const lcpObserver = new PerformanceObserver(entryList => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];
    if (lastEntry) {
      // Detected the LCP event
      lcpObserver.disconnect();
      requestAnimationFrame(callback); // Defer script loading
    }
  });
  lcpObserver.observe({
    type: 'largest-contentful-paint',
    buffered: true
  });
}
export default function loadSupportScripts(onLoad, product) {
  if (window.SUPPORT_SCRIPTS_LOADED || window.SKIP_SUPPORT_SCRIPTS_LOAD) return;
  window.SUPPORT_SCRIPTS_LOADED = true;
  onLCP(() => {
    loadZvaScripts(onLoad, product);
  });
}
//# sourceMappingURL=loadSupportScripts.js.map